module.exports = __webpack_public_path__ + "1b7344a5e7de1e6f6a242506f16e61da.png";